<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout
      :type="consts.meetingType.customer"
      @changeIsOperationPossible="changeIsOperationPossible"
    >
      <div class="base-color mh-550 shadow">
        <div class="p-2">
          <BOverlay :show="overlayShow" rounded="sm">
            <h5 class="text-dark-blue fw-bold pt-3">■お客様情報入力内容確認</h5>

            <form @submit.prevent>
              <div class="px-4">
                <div class="mb-3 row">
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 header-text-size"><span class="fw-bold">ご両家様名</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="bothFamilyName">
                      {{ getBothFamilyName1 }}・{{ getBothFamilyName2 }} <span class="ps-3" style="font-size:small">ご両家様</span>
                    </div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-sm-12 p-0">
                    <h5 class="fw-bold header-text-size">{{shinroShinpu1 !== 'shinro' ? '新婦様' : '新郎様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomName">{{getGroomLastName}} {{getGroomFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomNameKana">{{getGroomLastNameKana}} {{getGroomFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="groomPhoneNumber">{{getGroomPhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input header-text-size" id="mailAddress">{{getMailAddress}}</div>
                  </div>
                </div>
                <div class="mb-3 row">
                  <div class="col-sm-12 p-0">
                    <h5 class="fw-bold header-text-size">{{shinroShinpu2 !== 'shinpu' ? '新郎様' : '新婦様'}}</h5>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideName">{{getBrideLastName}} {{getBrideFirstName}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>お名前(カナ)</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="brideNameKana">{{getBrideLastNameKana}} {{getBrideFirstNameKana}}</div>
                  </div>
                  <div class="col-sm-12 row mt-1">
                    <div class="col-4 col-lg-3 p-0 ps-3"><span>電話番号</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break result-input" id="bridePhoneNumber">{{getBridePhoneNumber}}</div>
                  </div>
                  <div class="col-sm-12 row">
                    <div class="col-4 col-lg-3 p-0"><span>メールアドレス</span></div>
                    <div class="col-1 col-sm-1 p-0">：</div>
                    <div class="col-7 col-lg-8 text-break header-text-size" id="brideMailAddress">{{getBrideMailAddress}}</div>
                  </div>
                </div>
              </div>

              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【個人情報のお取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300">
                  <template v-for="(t, index) in consts.termsMsg.personalInformation" :key="`pi-${index}`">
                    <span>{{ t }}</span><br/>
                  </template>
                </div>

                <div class="col-sm-12 mb-3 mt-3 d-flex justify-content-center p-2">
                  <label
                    class="form-check-label labex-box-blue py-1 px-4"
                    for="personalInformationCheck"
                    :class="{ 'is-invalid': v$.personalInformationCheck.$error }"
                  >
                    <input
                      type="checkbox"
                      class="checkbox-scale-larger mt-2"
                      id="personalInformationCheck"
                      true-value="1"
                      false-value=""
                      v-model="personalInformationCheck"
                      @click="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意する
                  </label>
                </div>
                <div class="invalid-feedback d-block text-center">
                  {{ v$.personalInformationCheck.$error ? '同意が必要です' : '' }}
                </div>
              </div>

              <hr class="border-gray">

              <h5 class="header-bg-txt-color mt-5 mb-0 py-1">【画像の撮影・お取り扱いについて】</h5>
              <div class="col-sm-12 row px-0 mx-0">
                <div class="col-sm-12 overflow-auto border h-300">
                  <template v-for="(t, index) in consts.termsMsg.imageCheck" :key="`img-${index}`">
                    <span>{{ t }}</span><br/>
                  </template>
                </div>

                <div class="col-sm-12 mb-3 mt-3 d-flex justify-content-center p-2">
                  <label class="form-check-label labex-box-blue py-1 px-4 me-4" for="imageCheck">
                    <input
                      type="checkbox"
                      id="imageCheck"
                      true-value="1"
                      false-value=""
                      class="checkbox-scale-larger mt-2"
                      v-model="imageCheck"
                      @click="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意する
                  </label>

                  <label class="form-check-label labex-box py-1 px-3" for="imageCheckDisagree">
                    <input
                      type="checkbox"
                      id="imageCheckDisagree"
                      true-value="1"
                      false-value=""
                      class="checkbox-scale-larger mt-2"
                      v-model="imageCheckDisagree"
                      @click="sendSignalingInputData"
                      :disabled="!isOperationPossible"
                    />
                    同意しない
                  </label>
                </div>
              </div>

              <div class="col-sm-12 text-end mb-2 me-2">
                <BButton variant="outline-primary" class="w-25 sub-button-color back-button-disabled"
                  @click="backPage" :disabled="!isOperationPossible">戻る</BButton>
                <BButton variant="primary" class="w-25 ms-3 main-button-color next-button-disabled"
                  @click="nextPage" :disabled="!isOperationPossible">送信</BButton>
              </div>
            </form>
          </BOverlay>
        </div>
      </div>
    </CustomerMeetingLayout>

    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>

<script>
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import CommonLayout from '@/layout/CommonLayout'
import CommonModal from '@/components/CommonModal'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'

import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import SignalingModel from '@/models/SignalingModel'
import CustomerRegistModel from '@/models/CustomerRegistModel'
import CommonLogModel from '@/models/CommonLogModel'

export default {
  name: 'CustomerMeetingConfirm',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal },

  setup () {
    const router = useRouter()
    const { proxy } = getCurrentInstance()

    const commonModal = ref(null)
    const overlayShow = ref(false)

    const personalInformationCheck = ref('')
    const imageCheck = ref('')
    const imageCheckDisagree = ref('')

    const isSendFirstSignalingData = ref(false)
    const isOperationPossible = ref(false)

    const shinroShinpu1 = ref('shinro')
    const shinroShinpu2 = ref('shinpu')
    const customerDisplayFlag = ref(cstore.getters.customerDisplayFlag ?? false)

    // consts はどこかで inject / globalProperties なら proxy から参照
    const consts = proxy?.consts

    // Vuelidate
    const rules = computed(() => ({
      personalInformationCheck: { required }
    }))
    const v$ = useVuelidate(rules, { personalInformationCheck })

    // computed（表示用）
    const getBothFamilyName1 = computed(() => cstore.getters.bothFamilyName1)
    const getBothFamilyName2 = computed(() => cstore.getters.bothFamilyName2)
    const getGroomLastName = computed(() => cstore.getters.groomLastName)
    const getGroomFirstName = computed(() => cstore.getters.groomFirstName)
    const getGroomLastNameKana = computed(() => cstore.getters.groomLastNameKana)
    const getGroomFirstNameKana = computed(() => cstore.getters.groomFirstNameKana)
    const getGroomPhoneNumber = computed(() => cstore.getters.groomPhoneNumber)
    const getBrideLastName = computed(() => cstore.getters.brideLastName)
    const getBrideFirstName = computed(() => cstore.getters.brideFirstName)
    const getBrideLastNameKana = computed(() => cstore.getters.brideLastNameKana)
    const getBrideFirstNameKana = computed(() => cstore.getters.brideFirstNameKana)
    const getBridePhoneNumber = computed(() => cstore.getters.bridePhoneNumber)
    const getMailAddress = computed(() => cstore.getters.mailAddress)
    const getBrideMailAddress = computed(() => cstore.getters.brideMailAddress)

    const getIsTargetAtendeeActive = computed(() => mstore.getters.isTargetAtendeeActive)
    const getSignalingData = computed(() => cstore.getters.signalingReceiveData)

    const toggleAgreeButton = (targetElm) => {
      if (targetElm.id === 'imageCheck') {
        imageCheckDisagree.value = targetElm.checked ? '' : '1'
        const el = document.getElementById('imageCheckDisagree')
        if (el) el.checked = !targetElm.checked
      } else {
        imageCheck.value = targetElm.checked ? '' : '1'
        const el = document.getElementById('imageCheck')
        if (el) el.checked = !targetElm.checked
      }
    }

    const sendSignalingInputData = (e) => {
      try {
        if (!isOperationPossible.value) return

        const clickedElmID = e?.target?.id ?? ''
        if (clickedElmID === 'imageCheck' || clickedElmID === 'imageCheckDisagree') {
          toggleAgreeButton(e.target)
        }

        const sendData = []
        const resultInputs = document.getElementsByClassName('result-input')
        for (let i = 0; i < resultInputs.length; i++) {
          sendData.push({ id: resultInputs[i].id, value: resultInputs[i].innerHTML })
        }
        const checkInputs = document.querySelectorAll('input[type="checkbox"]')
        for (let i = 0; i < checkInputs.length; i++) {
          sendData.push({ id: checkInputs[i].id, value: checkInputs[i].checked })
        }

        SignalingModel.sendInputEvent(proxy, sendData) // ★proxy必須
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.sendSignalingInputData',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const nextPage = async () => {
      try {
        const ok = await v$.value.$validate()
        if (!ok) return

        const imageFlag =
          imageCheck.value ? '01'
            : imageCheckDisagree.value ? '02'
              : '00'

        const params = {
          bothFamilyName1: cstore.getters.bothFamilyName1,
          bothFamilyName2: cstore.getters.bothFamilyName2,
          groomLastName: cstore.getters.groomLastName,
          groomFirstName: cstore.getters.groomFirstName,
          groomLastNameKana: cstore.getters.groomLastNameKana,
          groomFirstNameKana: cstore.getters.groomFirstNameKana,
          groomPhoneNumber: cstore.getters.groomPhoneNumber,
          brideLastName: cstore.getters.brideLastName,
          brideFirstName: cstore.getters.brideFirstName,
          brideLastNameKana: cstore.getters.brideLastNameKana,
          brideFirstNameKana: cstore.getters.brideFirstNameKana,
          bridePhoneNumber: cstore.getters.bridePhoneNumber,
          mailAddress: cstore.getters.mailAddress,
          brideMailAddress: cstore.getters.brideMailAddress,
          shinroShinpu1: cstore.getters.shinroShinpu1,
          shinroShinpu2: cstore.getters.shinroShinpu2,
          personalInformationFlag: personalInformationCheck.value ? '01' : '00',
          imageFlag
        }

        overlayShow.value = true
        const customerRegistModel = await CustomerRegistModel.apiSetStore(null, params, () => {
          overlayShow.value = false
        })
        overlayShow.value = false

        if (!customerRegistModel) {
          await commonModal.value?.msgBoxOk('お客様情報の更新に失敗しました')
          return
        }
        if (customerRegistModel.status !== 'success' || customerRegistModel.message) {
          await commonModal.value?.msgBoxOk(customerRegistModel.message)
          return
        }

        const targetPath = '/customer/meeting/send_mail'
        // ★Signalingの失敗で遷移が止まらないよう分離してもOK
        SignalingModel.sendClickEvent('next', proxy, { target_path: targetPath.replace('customer', 'florist') })
        await router.push(targetPath)
      } catch (err) {
        overlayShow.value = false
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.nextPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const backPage = async () => {
      try {
        const targetPath = '/customer/meeting/input'
        SignalingModel.sendClickEvent('back', proxy, { target_path: targetPath.replace('customer', 'florist') })
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.backPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const signalingNextPage = async (targetPath) => {
      try {
        if (targetPath === '/customer/meeting/send_mail') {
          const ok = await v$.value.$validate()
          if (!ok) return
        }
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.signalingNextPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const signalingBackPage = async (targetPath) => {
      try {
        await router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.signalingBackPage',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }

    const changeIsOperationPossible = (value) => {
      isOperationPossible.value = value
    }

    // watch: 疎通確立
    watch(getIsTargetAtendeeActive, (active) => {
      if (!active) return

      // 必須値チェック（元ロジック踏襲）
      if (!cstore.getters.bothFamilyName1 ||
          !cstore.getters.bothFamilyName2 ||
          !cstore.getters.groomLastName ||
          !cstore.getters.groomFirstName ||
          !cstore.getters.groomPhoneNumber ||
          !cstore.getters.brideLastName ||
          !cstore.getters.brideFirstName ||
          !cstore.getters.bridePhoneNumber ||
          !cstore.getters.mailAddress ||
          !cstore.getters.brideMailAddress
      ) {
        cstore.commit('setErrorMsg', '値が不正です')
        backPage()
        return
      }

      if (!isSendFirstSignalingData.value) {
        sendSignalingInputData()
        isSendFirstSignalingData.value = true
      }
    })

    // watch: signaling受信
    watch(getSignalingData, (newData) => {
      try {
        if (!newData) return

        const payload = { ...newData, user: 'customer', timestampMs: Date.now() }
        CommonLogModel.apiSetStore(null, payload, () => {})

        if (newData.event === 'click') {
          if (sessionStorage.customerType !== consts.customerType.guest) {
            if (newData.id === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              isOperationPossible.value = false
            } else if (newData.id === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              isOperationPossible.value = true
            }
          }

          if (newData.id === 'next') {
            const path = (sessionStorage.customerType === consts.customerType.guest || sessionStorage.customerType === consts.customerType.main)
              ? newData.target_path.replace('florist', 'customer')
              : newData.target_path
            signalingNextPage(path)
          }

          if (newData.id === 'back') {
            const path = (sessionStorage.customerType === consts.customerType.guest || sessionStorage.customerType === consts.customerType.main)
              ? newData.target_path.replace('florist', 'customer')
              : newData.target_path
            signalingBackPage(path)
          }

          if (newData.id === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            customerDisplayFlag.value = cstore.getters.customerDisplayFlag
          } else if (newData.id === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            customerDisplayFlag.value = cstore.getters.customerDisplayFlag
          }
        }

        // 操作不可時の input 反映（元ロジック踏襲）
        if (!cstore.getters.isOperationPossible && newData.event === 'input') {
          for (let i = 0; i < newData.data.length; i++) {
            const d = newData.data[i]
            if (!d?.id) continue
            const elm = document.getElementById(d.id)
            if (!elm) continue

            if (elm.getAttribute('type') === 'checkbox') {
              elm.checked = d.value
              elm.value = d.value ? 1 : ''
              elm.dispatchEvent(new Event('change'))
            } else {
              elm.innerHTML = d.value
            }
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.watch(getSignalingData)',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    }, { deep: true })

    onMounted(() => {
      try {
        // スクロール位置を一番上にする
        window.scrollTo(0, 0);
        isOperationPossible.value = cstore.getters.isOperationPossible
        cstore.commit('setIsOperationPossible', isOperationPossible.value)

        if (!isSendFirstSignalingData.value && mstore.getters.isTargetAtendeeActive) {
          sendSignalingInputData()
          isSendFirstSignalingData.value = true
        }

        shinroShinpu1.value = cstore.getters.shinroShinpu1
        shinroShinpu2.value = cstore.getters.shinroShinpu2
      } catch (err) {
        CommonLogModel.apiSetStore(null, {
          where: 'CustomerMeetingConfirm.mounted',
          timestampMs: Date.now(),
          errorMessage: err?.message || String(err),
          errorStack: err?.stack || null
        }, () => {})
      }
    })

    return {
      consts,
      commonModal,
      overlayShow,
      personalInformationCheck,
      imageCheck,
      imageCheckDisagree,
      isOperationPossible,
      shinroShinpu1,
      shinroShinpu2,
      customerDisplayFlag,

      v$,

      getBothFamilyName1,
      getBothFamilyName2,
      getGroomLastName,
      getGroomFirstName,
      getGroomLastNameKana,
      getGroomFirstNameKana,
      getGroomPhoneNumber,
      getBrideLastName,
      getBrideFirstName,
      getBrideLastNameKana,
      getBrideFirstNameKana,
      getBridePhoneNumber,
      getMailAddress,
      getBrideMailAddress,

      sendSignalingInputData,
      nextPage,
      backPage,
      signalingNextPage,
      signalingBackPage,
      changeIsOperationPossible
    }
  }
}
</script>
